import { Wrapper, Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const topLevel = Wrapper(styled.div`position: relative`);

const variables = Wrapper(styled.div`
  --tooltip-text-color: white;
  --tooltip-background-color: ${window?.settings?.secondary_color ?? '#04333b'};
  --tooltip-margin: 30px;
  --tooltip-arrow-size: 6px;
  --tooltip-display: hidden;
  
  &:hover {
      --tooltip-display: initial;
  }
`);

const tooltipWrapperTemplate = styled.div`
  position: absolute;
  transition-delay: 0.4s;

  visibility: var(--tooltip-display);
  &:after {
    ${({ displayState }) => css`
        content: "${displayState.content}";
    `}
    ${({ displayState }) => css`
      position:${displayState?.direction === 'top' ? '' : 'absolute'};
    `} 
    border-radius: 4px;
    left: 50%;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    color: var(--tooltip-text-color);
    font-size: 12px;
    line-height: 24px;
    background: var(--tooltip-background-color);
    z-index: 999;
    white-space: nowrap;
  }
  
  &:before {
    content: " ";
    left: 50%;
    border: solid transparent;
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-width: var(--tooltip-arrow-size);
    margin-left: calc(var(--tooltip-arrow-size) * -1);
  }

  ${({ displayState }) => displayState.direction === 'top' && css`
    top: calc(var(--tooltip-margin) * -1);
    &:before {
      top: 100%;
      border-top-color: var(--tooltip-background-color);
    }
  `}

  ${({ displayState }) => displayState.direction === 'right' && css`
    left: calc(100% + var(--tooltip-margin));
    top: 50%;

    &:after {
      left: calc(100%);
      top: 50%;
      transform: translateX(0) translateY(-50%);
    }

    &:before {
      left: calc(var(--tooltip-arrow-size) * -1);
      top: 50%;
      transform: translateX(0) translateY(-50%);
      border-right-color: var(--tooltip-background-color);
    }
  `}

  ${({ displayState }) => displayState.direction === 'bottom' && css`
    bottom: calc(var(--tooltip-margin) * -1);
    &:before {
      bottom: 100%;
      border-bottom-color: var(--tooltip-background-color);
    }
  `}

  ${({ displayState }) => displayState.direction === 'left' && css`
    top: 50%;
    &:after {
        left: auto;
        right: calc(100% + 22px);
        top: 50%;
        transform: translateX(0) translateY(-50%);
    }
    
    &:before {
      left: auto;
      top: 50%;
      transform: translateX(-135%) translateY(-50%);
      border-left-color: var(--tooltip-background-color);
    }
  `}
`;

const tooltipWrapper = Atom({ template: tooltipWrapperTemplate, type: 'label', dataType: 'string' });

export default (element) => {
  const { tooltip, ...el } = element;
  return {
    wrapper: topLevel,
    name: '__transparent__',
    key: `ToolTipTop${el.name}`,
    elements: [
      {
        wrapper: variables,
        name: '__transparent__',
        elements: [
          el,
          {
            component: tooltipWrapper,
            name: 'ToolTip',
            displayValue: () => '',
            displayState: () => tooltip
          }
        ]
      }
    ]
  };
};
